<template>
  <div
    v-if="!loading"
    class="multiselect-filter"
    id="category-selector"
  >
    <multiselect
      :id="id"
      searchable
      :showLabels="false"
      :disabled="disabled"
      :placeholder="$t(placeholder)"
      :options="categoryList"
      :customLabel="customLabel"
      :value="selectedCategoryObject"
      :clear-on-select="false"
      :close-on-select="false"
      :label="'name'"
      :custom-label="customLabel"
      :hideSelected="false"
      track-by="subcategoryId"
      :internal-search="false"
      @search-change="_search"
      @input="emitSelected"
      @close="_resetCategories"
    >
      <div
        class="caret"
        slot="caret"
        slot-scope="{ toggle }"
        @mousedown.prevent.stop="toggle"
      >
        <i
          class="Ctrl Ctrl--16"
          aria-hidden="true"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Edit"
          >
            <use xlink:href="#dropdown-icon"></use>
          </svg>
        </i>
      </div>
      <template
        slot="singleLabel"
        slot-scope="{ option }"
      >
        <span class="text-test">{{option.name}}</span>
      </template>
      <template
        slot="option"
        slot-scope="props"
      >
        <div
          class="title"
          v-if="props.option.type === 'TITLE'"
        >
          <span class="label form--label">{{  props.option.name.toUpperCase()}}</span>
        </div>

        <div
          class="d-flex align-items-center highlighted"
          :class="{'label form--label': props.option.type === 'DEFAULT'}"
          :style="props.option.style"
          v-if="props.option.type ==='DEFAULT' || props.option.type==='CUSTOM'"
        >

          <!-- <div
            class="title d-flex flex-column"
            v-if="props.search"
          >
            <span
              class="label form--label"
              :style="getCategoryColor(props.option)"
            >
              {{getCategoryName(props.option)}}

            </span>
            <span
              class="item Fuell-Text pl-4"
              v-if="props.option.type === 'CUSTOM'"
            > {{props.option.name}} </span>

          </div> -->
          <span
            class="item Fuell-Text"
            v-if="props.option.type === 'CUSTOM'"
          > {{props.option.name}} </span>
          <span
            class="item title"
            v-if="props.option.type === 'DEFAULT' "
          > {{props.option.name.toUpperCase()}} </span>
        </div>
        <div
          class="separator"
          v-if="props.option.type === 'SEPARATOR'"
        ></div>
      </template>
      <template slot="noOptions">
        {{ $t('multiselect_no_categories_found')}}
      </template>
      <template slot="noResult">
        <span class="no-result">
          {{ $t('multiselect_no_categories_found') }}
        </span>
      </template>

    </multiselect>

  </div>
</template>

<script>
import _transactionCategoriesHandler from '../../_mixins/_transactionCategoriesHandler'
import Multiselect from 'vue-multiselect'
import { categoriesColors } from '../../_constants/constants'
import unknownCategory from '@/assets/img/icons/categories/other-icon.svg'
export default {
  name: 'CategorySelector',
  mixins: [_transactionCategoriesHandler],
  components: { Multiselect },
  props: {
    id: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'transactions_edit_transaction_category'
    },
    selectedCategoryObject: {
      type: [Object, String]
    },
    filterMode: {
      type: Boolean,
      default: false
    },
    userIsOwnerOfTransaction: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: null,
      categoryList: [],
      originalCategoryList: [],
      internalId: 0,
      loading: true
    }
  },
  computed: {
    transaction () {
      return this.$store.getters['TransactionsStore/currentTransaction']
    },
    categories () {
      return this.$store.getters['CategoriesStore/categories'] || []
    },
    defaultCategoriesOffice () {
      return this.$store.getters['CategoriesStore/defaultCategoriesOffice'] || []
    },
    customCategories () {
      return this.$store.getters['CategoriesStore/customCategories'] || []
    },
    recentCategories () {
      return this.$store.getters['CategoriesStore/userRecentCategories'] || []
    },
    categoriesColors () {
      return categoriesColors
    },
    userId () {
      return this.$store.getters['LoginStore/loggedUserId'] ?? 0
    }

  },
  methods: {
    emitSelected (event) {
      let categoryObject = { ...event }
      delete categoryObject.icon
      delete categoryObject.style
      this.$emit('categorySelected', categoryObject)
    },
    customLabel (value) {
      return value.name
    },
    generateCategoryLabelName (option) {
      return option.name
    },
    getCategoryName (option) {
      const cat = this.categoryList.find(el => el.categoryId === option.categoryId)

      return cat?.name?.toUpperCase()
    },
    getCategoryColor (option) {
      const categoryColor = this.categories.find(el => el.id === option.categoryId)

      let colorStyle = {}
      if (option && option.categoryId && categoryColor) {
        colorStyle['color'] = categoryColor.color
        return colorStyle
      }

      if (option && option.subcategoryId) {
        colorStyle['color'] = '#162743'
        return colorStyle
      }
      return ''
    },
    categoryHasSearchResult (option, searchValue) {
      if (!searchValue || !option) return false
      if (option.categoryId && option.type === 'DEFAULT') {
        const categoryToCheck = this.categories.find(el => el.defaultCategoryOffice?.id === option.categoryId)

        if (categoryToCheck?.id) {
          let { customCategories } = categoryToCheck
          return customCategories.filter(el => el.name.toLowerCase().includes(searchValue.toLowerCase())).length > 0
        }
      }
      return false
    },

    mergeDefaultCategoriesOffice () {
      this.categories.forEach(category => {
        let defaultCategoryOffice = this.defaultCategoriesOffice.find(item => item.id === category.id)
        category.defaultCategoryOffice = defaultCategoryOffice || {}
      })
    },
    mergeCustomCategories () {
      this.categories.forEach(category => {
        let customCategories = this.customCategories.filter(item => item.defaultCategoryOffice?.id === category.id)

        category.customCategories = customCategories || {}
      })
    },
    _search (searchValue) {
      if (!searchValue) return
      this.categoryList = [...this.originalCategoryList]
      let result = []
      this.categoryList.forEach(el => {
        // Check if category has subcategories that match searchValue,if it does, add category, then the subcategories that match
        if (el.type === 'DEFAULT' && !el.recent) {
          if (this.categoryHasSearchResult(el, searchValue)) {
            result.push(el)
          }
        }

        if (el.type === 'CUSTOM' && !el.recent) {
          if (el.name.toLowerCase().includes(searchValue.toLowerCase())) {
            result.push(el)
          }
        }
      })

      this.categoryList = [...result]
    },
    _initializeCategories () {
      const options = []

      const recentCategories = [...this._initializeRecentCategories()]
      const rawRecentcategories = JSON.parse(JSON.stringify(recentCategories))
      const rawCategoriesList = JSON.parse(JSON.stringify(this.categories))

      const rawCategories = [...rawRecentcategories, ...rawCategoriesList]
      rawCategories.forEach(rawCategory => {
        // Procesado categorías normales

        if (
          rawCategory.customCategories &&
          rawCategory.customCategories.length >= 0
        ) {
          if (rawCategory.customCategories.length > 0) {
            options.push({
              internalId: this.internalId,
              categoryId: rawCategory.id,
              name: rawCategory.name,
              code: rawCategory.code,
              $isDisabled: true,
              type: 'DEFAULT',
              taxCode:
                rawCategory.defaultCategoryOffice &&
                  rawCategory.defaultCategoryOffice.taxCode
                  ? rawCategory.defaultCategoryOffice.taxCode
                  : null

            })
            this.internalId++

            rawCategory.customCategories.forEach(sub => {
              options.push({
                internalId: this.internalId,
                categoryId: rawCategory.id,
                categoryName: rawCategory.name,
                subcategoryId: sub.id,
                name: sub.name,
                taxCode: sub.taxCode,
                code: rawCategory.code,
                type: 'CUSTOM'

              })
              this.internalId++
            })
          }
        } else {
          // Procesado categorías recientes
          if (rawCategory?.type === 'TITLE') {
            options.push({
              internalId: this.internalId,
              type: rawCategory?.type,
              name: rawCategory?.name,
              $isDisabled: true
            })
          }
          if (rawCategory?.type === 'SEPARATOR') {
            options.push({
              internalId: this.internalId,
              type: rawCategory?.type,
              $isDisabled: true
            })
          }
          if (rawCategory?.defaultCategoryOffice && !rawCategory.type) {
            // Custom

            options.push({
              internalId: this.internalId,
              subcategoryId: rawCategory.id,
              name: rawCategory.name,
              taxCode: rawCategory.taxCode,
              code: rawCategory.code,
              type: 'CUSTOM',
              recent: true

            })
            this.internalId++
          } else if (!rawCategory.type) {
            // default

            options.push({
              internalId: this.internalId,
              categoryId: rawCategory.id,
              name: rawCategory.name,
              code: rawCategory.code,
              $isDisabled: true,
              taxCode: rawCategory.taxCode ?? null,
              type: 'DEFAULT',
              recent: true

            })
            this.internalId++
          }
        }
      })
      this.categoryList = [...options]
      this._initializeCategoryColors()
      this._initializeCategoryIcon()
    },
    _initializeRecentCategories () {
      let recentCategoriesOptionList = []
      if (this.recentCategories.length === 0) return []
      if (this.customCategories.length >= 10 && this.userIsOwnerOfTransaction) {
        recentCategoriesOptionList.push({
          name: this.$i18n.t('MULTISELECT_OPTION_LABEL_RECENT'),
          $isDisabled: true,
          type: 'TITLE'
        })
        this.recentCategories.forEach(recentCategory => {
          if (recentCategoriesOptionList.length === 0) {
            recentCategoriesOptionList.push(recentCategory.defaultCategoryOffice)
            let subcategoriesFromOption = this.recentCategories.filter(el => el.defaultCategoryOffice.id === recentCategory.defaultCategoryOffice.id)

            recentCategoriesOptionList.push(...subcategoriesFromOption)
          } else {
            let option = recentCategoriesOptionList.find(option => recentCategory.defaultCategoryOffice.id === option.defaultCategoryOffice?.id)

            if (!option?.id) {
              let cat = option?.defaultCategoryOffice ?? recentCategory.defaultCategoryOffice

              if (cat?.id) {
                recentCategoriesOptionList.push(cat)
                let subCategoriesFromOption = this.recentCategories.filter(el => el.defaultCategoryOffice.id === cat.id)

                recentCategoriesOptionList.push(...subCategoriesFromOption)
              }
            }
          }
        })

        recentCategoriesOptionList.push({
          type: 'SEPARATOR'
        })
        recentCategoriesOptionList.push({
          name: this.$i18n.t('MULTISELECT_OPTION_LABEL_ALL'),
          $isDisabled: true,
          type: 'TITLE'
        })
      }

      return recentCategoriesOptionList
    },
    _initializeCategoryColors () {
      this.categoryList.forEach(cat => {
        cat.style = { ...this.getCategoryColor(cat) }
      })
    },
    _initializeCategoryIcon () {
      this.categoryList.forEach(cat => {
        if (cat.categoryId && !cat.subcategoryId) {
          const fullCategory = this.categories.find(el => el.id === cat.categoryId)
          if (fullCategory) {
            cat.icon = this.checkValidImageUrl(fullCategory.imageUrl) ? fullCategory.imageUrl : unknownCategory
          }
        }
      })
    },
    _resetCategories () {
      this.categoryList = [...this.originalCategoryList]
    },
    checkValidImageUrl (url) {
      if (url) {
        let hasValidExtension = this.validExtensions.some(el => url.includes(el))

        return hasValidExtension
      }
      return false
    }

  },
  created () {
    const promises = []
    promises.push(this.$store.dispatch('CategoriesStore/fetchCustomCategories', false))
    promises.push(this.$store.dispatch('CategoriesStore/fetchDefaultCategoriesOffice'))
    promises.push(this.$store.dispatch('CategoriesStore/fetchUserRecentCategories', this.userId))

    Promise.allSettled(promises).then(() => {
      this.mergeDefaultCategoriesOffice()
      this.mergeCustomCategories()
      this._initializeCategories()
      if (!this.filterMode) {
        this.selectedCategory = this.transaction.defaultCategoryOffice
          ? this.transaction.defaultCategoryOffice.id
          : ''
        this.selectedSubCategory = this.transaction.customCategory
          ? this.transaction.customCategory.id
          : ''

        this.$emit('update:selectedCategoryObject', this.getSelectedCategoryObject(
          this.selectedCategory,
          this.selectedSubCategory
        ))
        this.originalCategoryData = this.selectedCategoryObject
          ? { ...this.selectedCategoryObject }
          : null
      }
      this.originalCategoryList = [...this.categoryList]
      this.loading = false

      this.$emit('categoryLoaded', true)
    })
    // this.selected = this.value
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/multiselect/base.scss";
</style>
<style lang="scss">
#category-selector {
  .multiselect__option--highlight > .highlighted > .item {
    color: var(--text-body);
    opacity: 1 !important;
  }
  .multiselect__option--selected > .highlighted > .item {
    font-weight: 400;
    outline: none;
    color: var(--text-heading) !important;
  }
  .multiselect .multiselect__option:has(.separator) {
    padding: 10px 5px;
    min-height: 10px;
  }

  .multiselect .multiselect__option:has(.title) {
    padding: 7px 12px;
    min-height: 24px;
  }

  .separator {
    background-color: var(--fill-divider);
    width: 100%;
    height: 1px;
  }
}
</style>
